import React from 'react'

const ItemSelectableWithStatusAndCheck = ({ children, statusColor, statusLabel, checked, onChange, name, disabled }) => {
    return (
        <div className='white-bg shadow rounded-4 pt-3 pb-3 ps-4 pe-4'>
            <div className='d-flex align-items-center justify-content-between'>
                <div>
                    {children}
                </div>
                <div className='d-flex flex-column justify-content-between align-items-end'>
                    <h6
                        className='badge pe-4 ps-4'
                        style={{ background: statusColor }}
                    >
                        {statusLabel}
                    </h6>
                    <div className="form-check pt-3">
                        <input
                            id={"flexCheckDefault"}
                            className="form-check-input"
                            type="checkbox"
                            checked={checked}
                            name={name}
                            onChange={onChange}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItemSelectableWithStatusAndCheck